import React from 'react'

const CheckWmoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path
      d="M2.5 8.87376L3.56004 7.84888L6.25136 10.4502L13.44 3.5L14.5 4.52489L6.25061 12.5L2.5 8.87376Z"
      fill="white"
    />
  </svg>
)

export default CheckWmoIcon
